const getters = {
  protalUrl: () => {
    // 业务系统地址
    // return process.env.VUE_APP_protalUrl;
    // return 'http://172.16.150.41:8084/csAdmin'
    //return 'http://36.142.16.26:10660/csAdmin'
    // return 'http://localhost:9537/csAdmin'
    //return 'http://www2.gsxyd.cn/csAdmin'  // 试运行
    return 'https://www.gsxyd.cn/csAdmin'  // 正式互联网
    // return 'http://59.219.204.222:3000/csAdmin'  // 正式内网
      //return new URL(window.location.href).origin +"/csAdmin";
  },
  menhuUrl: () => {
    // 市门户地址
    // return process.env.VUE_APP_menhuUrl;
    return ''
  },
  cloginUrl: () => {
    // 省平台登录地址
    // return process.env.VUE_APP_cloginUrl;
    return ''
  },
  cregisterUrl: () => {
    // 省平台注册地址
    // return process.env.VUE_APP_cregisterUrl;
    return ''
  },
  ngImgPath: () => {
    // 图片地址
    // return process.env.VUE_APP_ngImgPath;
    return ''
  },
  greenFinUrl: () => {
    //绿色金融
    // return process.env.VUE_APP_greenFinUrl;
    return ''
  },
  roles: state => state.user.roles,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  permissions: state => state.user.permissions,
  certiFlg: state => state.user.certiFlg || null,
  dict: state => state.user.dict,
  companyId: state => state.user.companyId,
  loginDialogStatus: state => state.user.loginDialogStatus,
  currSubstation: state => state.user.currSubstation,
  userSourceType: state => state.user.userSourceType

}

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js